// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__Ff8Ea","spinner":"Loading_spinner__1nsqM"};